import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

export function Panel({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-rs border border-rs-border bg-rs-elevated shadow-rs",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function PanelHeader({
  title,
  description,
  action,
  titleAside,
  className,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  /** Inline control beside the title (e.g. a text “View All” link). */
  titleAside?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-wrap items-center justify-between gap-3 border-b border-rs-border px-5 py-4",
        className,
      )}
    >
      <div>
        <div className="flex flex-wrap items-baseline gap-2">
          <h2 className="text-base font-semibold text-rs-ink">{title}</h2>
          {titleAside}
        </div>
        {description ? (
          <p className="mt-1 text-sm text-rs-ink-muted">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
